import { IInstructionDTO } from '../../dto/instruction/instruction.dto';
import { IInstructionStepDTO } from '../../dto/instruction/instruction-step.dto';

const instructionStepDTOs: IInstructionStepDTO[] = [
  {
    title: $localize`:@@page-avatar-downloader-content-instruction-section-step-0-title:Copy the profile link`,
    description: $localize`:@@page-avatar-downloader-content-instruction-section-step-0-description:Open the Instagram profile you want to save an avatar from and copy the URL from your browser’s address bar.`,
  },
  {
    title: $localize`:@@page-avatar-downloader-content-instruction-section-step-1-title:Paste the link`,
    description: $localize`:@@page-avatar-downloader-content-instruction-section-step-1-description:Go to our website and paste the URL into the designated box on our profile picture downloader for Instagram.`,
  },
  {
    title: $localize`:@@page-avatar-downloader-content-instruction-section-step-2-title:Start the download`,
    description: $localize`:@@page-avatar-downloader-content-instruction-section-step-2-description:Hit the “Download” button, and our tool will instantly process your request, making the avatar available for saving.`,
  },
  {
    title: $localize`:@@page-avatar-downloader-content-instruction-section-step-3-title:Access your saved avatars`,
    description: $localize`:@@page-avatar-downloader-content-instruction-section-step-3-description:Once downloaded, you can enjoy the saved profile pictures anytime, stored conveniently on your device.`,
  },
];

export const instructionDTO: IInstructionDTO = {
  title: $localize`:@@page-avatar-downloader-content-instruction-section-title:How to download Instagram profile pictures using our tool`,
  header: $localize`:@@page-avatar-downloader-content-instruction-section-header:Follow these steps for a quick and simple download process:`,
  steps: instructionStepDTOs,
  footer: $localize`:@@page-avatar-downloader-content-instruction-section-footer:Our Instagram profile picture downloader makes the process of collecting high-quality Instagram avatars quick and stress-free. Try it out today!`,
};
